/* @ngInject */

export default () => {
  var margin = { top: 10, right: 100, bottom: 20, left: 200 };
  var width = 960;
  var height = 65 - margin.top - margin.bottom;

  return {
    restrict: 'E',
    scope: {
      height: '@',
      legend: '@',
      data: '='
    },
    link: function (scope, element, attrs) {
      if (scope.height && !isNaN(parseInt(height))) {
        height = scope.height;
      }

      if (
        _.every(scope.data, function (d) {
          return !d.title && !d.subtitle;
        })
      ) {
        margin.left = 100;
      }

      var haveLegends = scope.legend != 'false';

      d3.bullet = function () {
        var orient = 'left';
        var reverse = false;
        var duration = 0;
        var ranges = bulletRanges;
        var markers = bulletMarkers;
        var measures = bulletMeasures;
        var labels = bulletLabels;
        var legends = bulletLegends;
        var tickFormat = null;

        function bullet(g) {
          g.each(function (d, i) {
            var rng = ranges.call(this, d, i).slice().sort(d3.descending);
            var mrk = markers.call(this, d, i).slice().sort(d3.descending);
            var mea = measures.call(this, d, i).slice().sort(d3.descending);
            var lbl = labels.call(this, d, i).slice().reverse();
            var lnd = legends.call(this, d, i).slice().reverse();

            var g = d3.select(this);

            var x1 = d3
              .scaleLinear()
              .domain([0, Math.max(rng[0], mrk[0], mea[0])])
              .range(reverse ? [width, 0] : [0, width]);
            var x0 = this.__chart__ || d3.scaleLinear().domain([0, Infinity]).range(x1.range());

            this.__chart__ = x1;
            var w0 = bulletWidth(x0);
            var w1 = bulletWidth(x1);

            var range = g.selectAll('rect.range').data(rng);
            range
              .enter()
              .append('rect')
              .attr('class', function (d, i) {
                return 'range s' + i;
              })
              .attr('width', w0)
              .attr('height', height)
              .attr('x', reverse ? x0 : 0)
              .transition()
              .duration(duration)
              .attr('width', w1)
              .attr('x', reverse ? x1 : 0);
            range
              .transition()
              .duration(duration)
              .attr('x', reverse ? x1 : 0)
              .attr('width', w1)
              .attr('height', height);

            var measure = g.selectAll('rect.measure').data(mea);
            measure
              .enter()
              .append('rect')
              .attr('class', function (d, i) {
                return 'measure s' + i;
              })
              .attr('width', w0)
              .attr('height', height / 2)
              .attr('x', reverse ? x0 : 0)
              .attr('y', height / 4)
              .transition()
              .duration(duration)
              .attr('width', w1)
              .attr('x', reverse ? x1 : 0);
            measure
              .transition()
              .duration(duration)
              .attr('width', w1)
              .attr('height', height / 2)
              .attr('x', reverse ? x1 : 0)
              .attr('y', height / 4);

            if (lbl && lbl.length) {
              var measureLabel = g
                .selectAll('text.measure')
                .data(mea)
                .enter()
                .append('g')
                .style('text-anchor', 'start')
                .attr('transform', 'translate(0,' + height / 2 + ')');

              measureLabel
                .append('text')
                .attr('fill', function (d, i) {
                  var w = x1(d) - x1(mea[i + 1]);
                  return w < 50 ? 'black' : 'white';
                })
                .attr('class', function (d, i) {
                  return 'overlay s' + i;
                })
                .attr('dx', '5')
                .text(function (d, i) {
                  return lbl[i].split(':')[0];
                })
                .attr('x', function (d, i) {
                  var x = x1(mea[i + 1]);
                  return isNaN(x) ? 0 : x < 150 ? 150 : x;
                });
              measureLabel
                .append('text')
                .attr('fill', function (d, i) {
                  var w = x1(d) - x1(mea[i + 1]);
                  return w < 50 ? 'black' : 'white';
                })
                .attr('class', function (d, i) {
                  return 'suboverlay s' + i;
                })
                .attr('dx', '5')
                .attr('dy', '1em')
                .text(function (d, i) {
                  return lbl[i].split(':')[1];
                })
                .attr('x', function (d, i) {
                  var x = x1(mea[i + 1]);
                  return isNaN(x) ? 0 : x < 150 ? 150 : x;
                });
            }

            var marker = g.selectAll('line.marker').data(mrk);
            marker
              .enter()
              .append('line')
              .attr('class', 'marker')
              .attr('x1', x0)
              .attr('x2', x0)
              .attr('y1', height / 6)
              .attr('y2', height * 0.85)
              .transition()
              .duration(duration)
              .attr('x1', x1)
              .attr('x2', x1);
            marker
              .transition()
              .duration(duration)
              .attr('x1', x1)
              .attr('x2', x1)
              .attr('y1', height / 6)
              .attr('y2', height * 0.85);

            if (lnd && lnd.length) {
              var legend = g
                .selectAll('.legend')
                .data(lnd)
                .enter()
                .append('g')
                .attr('class', 'legend')
                .attr('transform', function (d, i) {
                  return 'translate(0,' + i * 20 + ')';
                });

              legend
                .append('rect')
                .attr('x', width + 6)
                .attr('width', 18)
                .attr('height', 18)
                .attr('class', function (d, i) {
                  return 'measure s' + i;
                });

              legend
                .append('text')
                .attr('x', width + 30)
                .attr('y', 9)
                .attr('dy', '.35em')
                .style('text-anchor', 'start')
                .text(function (d) {
                  return d;
                });
            }

            var format = tickFormat || x1.tickFormat(8);
            var tick = g.selectAll('g.tick').data(x1.ticks(8), function (d) {
              return this.textContent || format(d);
            });
            var tickEnter = tick
              .enter()
              .append('g')
              .attr('class', 'tick')
              .attr('transform', bulletTranslate(x0))
              .style('opacity', 1e-6);
            tickEnter
              .append('line')
              .attr('y1', height)
              .attr('y2', height * 1.075);
            tickEnter
              .append('text')
              .attr('text-anchor', 'middle')
              .attr('dy', '1em')
              .attr('y', height * 1.075)
              .text(format);
            tickEnter
              .transition()
              .duration(duration)
              .attr('transform', bulletTranslate(x1))
              .style('opacity', 1);

            var tickUpdate = tick
              .transition()
              .duration(duration)
              .attr('transform', bulletTranslate(x1))
              .style('opacity', 1);
            tickUpdate
              .select('line')
              .attr('y1', height)
              .attr('y2', height * 1.075);
            tickUpdate.select('text').attr('y', height * 1.075);
            tick
              .exit()
              .transition()
              .duration(duration)
              .attr('transform', bulletTranslate(x1))
              .style('opacity', 1e-6)
              .remove();
          });
          d3.timerFlush();
        }

        bullet.orient = function (x) {
          if (!arguments.length) {
            return orient;
          }
          orient = x;
          reverse = orient === 'right' || orient === 'bottom';
          return bullet;
        };

        bullet.ranges = function (x) {
          if (!arguments.length) {
            return ranges;
          }
          ranges = x;
          return bullet;
        };

        bullet.markers = function (x) {
          if (!arguments.length) {
            return markers;
          }
          markers = x;
          return bullet;
        };

        bullet.measures = function (x) {
          if (!arguments.length) {
            return measures;
          }
          measures = x;
          return bullet;
        };

        bullet.labels = function (x) {
          if (!arguments.length) {
            return labels;
          }
          labels = x;
          return bullet;
        };

        bullet.legends = function (x) {
          if (!arguments.length) {
            return legends;
          }
          legends = x;
          return bullet;
        };

        bullet.width = function (x) {
          if (!arguments.length) {
            return width;
          }
          width = x;
          return bullet;
        };

        bullet.height = function (x) {
          if (!arguments.length) {
            return height;
          }
          height = x;
          return bullet;
        };

        bullet.tickFormat = function (x) {
          if (!arguments.length) {
            return tickFormat;
          }
          tickFormat = x;
          return bullet;
        };

        bullet.duration = function (x) {
          if (!arguments.length) {
            return duration;
          }
          duration = x;
          return bullet;
        };

        return bullet;
      };

      function bulletRanges(d) {
        return d.ranges;
      }

      function bulletMarkers(d) {
        return d.markers;
      }

      function bulletMeasures(d) {
        return d.measures;
      }

      function bulletLabels(d) {
        return d.labels && d.labels.length ? d.labels : [];
      }

      function bulletLegends(d) {
        return d.legends && d.legends.length ? d.legends : [];
      }

      function bulletTranslate(x) {
        return function (d) {
          return 'translate(' + x(d) + ',0)';
        };
      }

      function bulletWidth(x) {
        var x0 = x(0);
        return function (d) {
          return Math.abs(x(d) - x0);
        };
      }

      var chart = d3.bullet().width(width).height(height);
      var svg = d3
        .select(element[0])
        .selectAll('svg')
        .data(scope.data)
        .enter()
        .append('svg')
        .attr('class', 'd3-chart-bullet')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr(
          'viewBox',
          (haveLegends ? parseInt(margin.left) - 5 : '0') +
            ' 0 ' +
            (parseInt(width) + parseInt(margin.left) + parseInt(margin.right)) +
            ' ' +
            (parseInt(height) + parseInt(margin.top) + parseInt(margin.bottom) + 20)
        )
        .attr('preserveAspectRatio', 'xMinYMin')
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
        .call(chart);

      var title = svg
        .append('g')
        .style('text-anchor', 'end')
        .attr('transform', 'translate(-6,' + height / 2 + ')');
      title
        .append('text')
        .attr('class', 'title')
        .text(function (d) {
          return d.title;
        });
      title
        .append('text')
        .attr('class', 'subtitle')
        .attr('dy', '1em')
        .text(function (d) {
          return d.subtitle;
        });
    }
  };
};
